module.exports = __webpack_public_path__ + "img/Lapto-2-p-800.75739e23.png";